<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待审核" name="first">
          <after-sale-single v-if="activeName == 'first'" :tabCurrent="activeNum"></after-sale-single>
        </el-tab-pane>
        <el-tab-pane label="待寄回" name="second">
          <after-sale-single v-if="activeName == 'second'" :tabCurrent="activeNum"></after-sale-single>
        </el-tab-pane>
        <el-tab-pane label="驳回" name="third">
          <after-sale-single v-if="activeName == 'third'" :tabCurrent="activeNum"></after-sale-single>
        </el-tab-pane>
        <el-tab-pane label="已退款" name="fourth">
          <after-sale-single v-if="activeName == 'fourth'" :tabCurrent="activeNum"></after-sale-single>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import AfterSaleSingle from './components/AfterSaleSingle.vue'
export default {
  name: 'AfterSale',
  components: {
    AfterSaleSingle
  },
  data () {
    return {
      imgServer: this.$imgServer,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:0,
      countData:{
        needPayNum:0,
        needSendNum:0,
        needWriteOffNum:0
      }
    }
  },
  mounted () {
    this.countFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {
      if(tab.name === 'first'){
        this.activeNum = 0
      }else if(tab.name === 'second'){
        this.activeNum = 3
      }else if(tab.name === 'third'){
        this.activeNum = 2
      }else{
        this.activeNum = 1
      }
    },
    /* 统计数量 */
    countFun(){
      var that = this;
      // queryOrderPageCount({}).then((res) => {
      //   if (res.errorCode === '0000') {
      //     var data = res.data;
      //     that.countData = data;
      //   }
      // });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/AfterSale.vue